import { Component, OnInit, OnDestroy, ElementRef, ChangeDetectorRef, ViewChild, AfterViewInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ViewTableComponent } from '../../base/view-table/view-table.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import moment from 'moment';
import flatpickr from 'flatpickr';
import { LocalizationService } from 'src/app/services/localization.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { UtilityService } from 'src/app/services/utility.service';
import { DialogService } from 'src/app/services/dialog.service';
import { EntityRESTService } from 'src/app/services/entity-rest.service';
import { FieldsService } from 'src/app/services/fields.service';
import { DrupalRESTService } from 'src/app/services/drupal-rest.service';
import { TaxonomyService } from 'src/app/services/taxonomy.service';
import { AuthRESTService } from 'src/app/services/auth-rest.service';
import { AuthService } from 'src/app/services/auth.service';
import { MenuRESTService } from 'src/app/services/menu-rest.service';
import { FormBuilder } from '@angular/forms';
import { RouteEventsService } from 'src/app/route-events.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { ConfigPagesService } from 'src/app/services/config-pages.service';
import { PackagesService } from 'src/app/services/packages.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from 'src/app/services/user.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Renderer2 } from '@angular/core';
import { PrintService } from 'src/app/services/print.service';
import { RefreshService } from 'src/app/services/refresh.service';
import { StudioConfigService } from 'src/app/services/studio-config.service';
import { ComponentRefreshService } from 'src/app/services/component-refresh.service';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CurrencyService } from '../../../services/currency.service';
import { LoggerService } from '../../../services/logger.service';

@Component({
  selector: 'app-liability-report',
  templateUrl: './liability-report.component.html',
  styleUrls: ['./liability-report.component.css']
})
export class LiabilityReportComponent extends ViewTableComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(MatSort) override sort!: MatSort;
  @ViewChild(MatPaginator) override paginator!: MatPaginator;
  @ViewChild('f') override form!: NgForm;
  @ViewChild('dateRangeInput') dateRangeInput!: ElementRef;

  liabilityData: any[] = [];
  dateTimeRange: Date[] = [];
  isDateRangeActive: boolean = false;
  studentFilter: string = '';
  categoryFilter: string = '';
  dateRangeDisplayValue: string = '';
  private dateRangePicker?: flatpickr.Instance;
  private localizationService = new LocalizationService();

  // Default page size so the first paint isn't "items per page: 0" (base default is 0).
  override paginationTotalPages: number = 25;

  // Summary totals
  totalLessonsRemainingPaid: number = 0;
  totalLessonsRemainingUnpaid: number = 0;
  totalValuePaidRemaining: number = 0;
  totalValueUnpaidRemaining: number = 0;
  totalValueRemaining: number = 0;
  totalBalanceDueLessons: number = 0;
  totalOwedForServices: number = 0;
  totalExpiredValue: number = 0;
  totalPaidAhead: number = 0;
  totalLiability: number = 0;

  override displayedColumns: string[] = [
    'studentName',
    'lessonsRemainingPaid',
    'valuePaidRemaining',
    'lessonsRemainingUnpaid',
    'valueUnpaidRemaining',
    'totalValueRemaining',
    'balanceDueLessons',
    'owedForServices',
    'paidAhead',
    'expiredValue',
    'totalLiability'
  ];

  // First (group) header row: blank over Student Name, "# of Lessons Remaining"
  // spanning the 4 paid/unpaid columns, blank over the 6 dollar columns.
  groupHeaderColumns: string[] = [
    'group-student',
    'group-lessons-remaining',
    'group-rest'
  ];

  constructor(
    public override _refreshService: RefreshService,
    private _printService: PrintService,
    public override _dialogService: DialogService,
    public override _entityRESTService: EntityRESTService,
    public override _utilityService: UtilityService,
    public override _fieldsService: FieldsService,
    public override _drupalRESTService: DrupalRESTService,
    public override _taxonomyService: TaxonomyService,
    public override _router: Router,
    public override _activatedRoute: ActivatedRoute,
    public override _authRESTService: AuthRESTService,
    public override _authService: AuthService,
    public override _menuRESTService: MenuRESTService,
    public override _formBuilder: FormBuilder,
    public override _routeEventsService: RouteEventsService,
    public override _permissionsService: PermissionsService,
    public override _renderer2: Renderer2,
    public override _configPages: ConfigPagesService,
    public override _packagesService: PackagesService,
    public override _snackBar: MatSnackBar,
    public override _userRESTService: UserService,
    public override _el: ElementRef,
    public override _changeDetectorRef: ChangeDetectorRef,
    public override _sanitizer: DomSanitizer,
    public override _studioConfigService: StudioConfigService,
    public override _componentRefreshService: ComponentRefreshService,
    public override _translateService: TranslateService,
    private currencyService: CurrencyService,
  ) {
    super(
      _refreshService,
      _dialogService,
      _entityRESTService,
      _utilityService,
      _fieldsService,
      _drupalRESTService,
      _taxonomyService,
      _router,
      _activatedRoute,
      _authRESTService,
      _authService,
      _menuRESTService,
      _formBuilder,
      _routeEventsService,
      _permissionsService,
      _renderer2,
      _configPages,
      _packagesService,
      _snackBar,
      _userRESTService,
      _el,
      _changeDetectorRef,
      _sanitizer,
      _studioConfigService,
      _componentRefreshService,
      _translateService
    );
  }

  override ngOnInit(): void {
    this._activatedRoute.queryParams.subscribe(params => {
      if (params['date_from'] && params['date_to']) {
        const startDate = this.reportDateService.parseCalendarDateInput(params['date_from']);
        const endDate = this.reportDateService.parseCalendarDateInput(params['date_to']);

        if (startDate && endDate) {
          this.dateTimeRange = [startDate, endDate];
          this.isDateRangeActive = true;
        } else {
          this.dateTimeRange = [];
          this.isDateRangeActive = false;
        }
      } else {
        this.isDateRangeActive = false;
      }

      this.studentFilter = params['student_filter'] || params['student'] || '';
      this.categoryFilter = params['category_filter'] || params['category'] || '';

      // Seed routeParams from the URL every emission. The base pageChanged/sortDataView
      // spread this.routeParams, so active filters/sort survive a page or sort change.
      this.routeParams = { ...params };

      this.loadData(params);
    });
  }

  override dataSource = new MatTableDataSource<any>([]);

  ngAfterViewInit(): void {
    this.initDateRangePicker();
  }

  // Studio config is app-lifetime; released on destroy so the report can be collected.
  private datePickerConfigSubscription: Subscription;

  override ngOnDestroy(): void {
    this.dateRangePicker?.destroy();
    this.datePickerConfigSubscription?.unsubscribe();
    super.ngOnDestroy();
  }

  private initDateRangePicker(): void {
    if (!this.dateRangeInput?.nativeElement) return;

    this.datePickerConfigSubscription?.unsubscribe();
    this.datePickerConfigSubscription = this._studioConfigService.getStudioConfig().subscribe(config => {
      const countryCode = config?.['field_studio_address']?.[0]?.country_code || 'US';
      const formats = this.localizationService.getDateFormatsForCountry(countryCode);

      this.dateRangePicker = flatpickr(this.dateRangeInput.nativeElement, {
        mode: 'range',
        dateFormat: formats.flatpickrDateFormat,
        disableMobile: true,
        defaultDate: this.dateTimeRange?.length === 2 ? this.dateTimeRange : undefined,
        onChange: (selectedDates) => {
          if (selectedDates.length === 2) {
            this.dateTimeRange = selectedDates;
            this.isDateRangeActive = true;
            this.dateRangeDisplayValue = this.dateRangePicker?.input?.value || '';

            // Date filter change → reset to page 0 via the router, preserving sort.
            const rp: any = { ...this.buildRouteFilters(), page: '0' };
            if (this.routeParams?.sort_by) {
              rp.sort_by = this.routeParams.sort_by;
              rp.sort_order = this.routeParams.sort_order;
            }
            this.updateRouterParams(rp);
          }
        }
      });

      // Update display if dates were set from URL params
      if (this.dateTimeRange?.length === 2 && this.dateRangePicker) {
        this.dateRangePicker.setDate(this.dateTimeRange, false);
        this.dateRangeDisplayValue = this.dateRangePicker.input.value;
      }
    });
  }

  openDateRangePicker(): void {
    this.dateRangePicker?.open();
  }

  override onSubmit(form: NgForm): void {
    // Sync component filter state from the form before navigating.
    this.studentFilter = form.form.value?.['student_filter'] || '';
    this.categoryFilter = this.categoryFilter || '';

    // Apply a filter change via the router (page reset to 0, active sort preserved)
    // so the single route-driven getData() flow stays authoritative.
    const rp: any = { ...this.buildRouteFilters(), page: '0' };
    if (this.routeParams?.sort_by) {
      rp.sort_by = this.routeParams.sort_by;
      rp.sort_order = this.routeParams.sort_order;
    }
    this.updateRouterParams(rp);
  }

  /**
   * Active filter values as a router-params object (no paging/sort keys).
   */
  private buildRouteFilters(): any {
    const rp: any = {};
    if (this.isDateRangeActive && this.dateTimeRange?.length > 0) {
      rp.date_from = this.reportDateService.formatCalendarParam(this.dateTimeRange[0]);
      rp.date_to = this.reportDateService.formatCalendarParam(this.dateTimeRange[1]);
    }
    if (this.studentFilter) {
      rp.student_filter = this.studentFilter;
    }
    if (this.categoryFilter) {
      rp.category_filter = this.categoryFilter;
    }
    return rp;
  }

  override onAutocompleteStudent(event: any) {
    this.onAutocompleteStudentAccount(event);
  }

  loadData(urlParams: Params = this._activatedRoute.snapshot.queryParams) {
    this.getData(this.buildParams(urlParams));
  }

  /**
   * Build the request params array: filters from component state + paging/sort
   * lifted out of the URL. Server-side paging is driven by these keys, so they
   * must be forwarded (not rebuilt from component state, which drops them).
   */
  private buildParams(urlParams: Params = {}): { parameter: string; value: string }[] {
    const params: { parameter: string; value: string }[] = [];

    if (this.isDateRangeActive && this.dateTimeRange?.length > 0) {
      params.push({ parameter: 'date_from', value: this.reportDateService.formatCalendarParam(this.dateTimeRange[0]) });
      params.push({ parameter: 'date_to', value: this.reportDateService.formatCalendarParam(this.dateTimeRange[1]) });
    }
    if (this.studentFilter) {
      params.push({ parameter: 'student_filter', value: this.studentFilter });
    }
    if (this.categoryFilter) {
      params.push({ parameter: 'category_filter', value: this.categoryFilter });
    }

    params.push({ parameter: 'page', value: urlParams['page'] != null ? String(urlParams['page']) : '0' });
    params.push({ parameter: 'items_per_page', value: urlParams['items_per_page'] != null ? String(urlParams['items_per_page']) : '25' });
    if (urlParams['sort_by']) {
      params.push({ parameter: 'sort_by', value: String(urlParams['sort_by']) });
    }
    if (urlParams['sort_order']) {
      params.push({ parameter: 'sort_order', value: String(urlParams['sort_order']) });
    }

    return params;
  }

  /**
   * Fetch EVERY matching row (not just the current page) with the active filters
   * and sort, for export/print. The table is paged server-side, so liabilityData
   * holds only one page; export/print must cover the full set.
   */
  private fetchAllRows(): Promise<any[]> {
    const params = this.buildParams(this._activatedRoute.snapshot.queryParams)
      .filter(p => p.parameter !== 'page' && p.parameter !== 'items_per_page');
    params.push({ parameter: 'page', value: '0' });
    params.push({ parameter: 'items_per_page', value: '250' });

    return new Promise(resolve => {
      this._drupalRESTService.httpGET('/api/loadLiabilityReport', params).subscribe({
        next: data => {
          const rows = data?.['liability_data'] || [];
          // The backend caps items_per_page at 250. If a studio ever exceeds that
          // many students with liability, the export would truncate. Warn loudly.
          if (Number(data?.['count'] ?? 0) > rows.length) {
            LoggerService.warn(`Liability export truncated: ${data['count']} rows, showing ${rows.length}.`);
          }
          resolve(rows);
        },
        error: () => resolve(this.liabilityData),
      });
    });
  }

  override getData(params: { parameter: string; value: string }[]) {
    this.ShowProgressBar = true;
    this.queryParams = params;

    this._drupalRESTService.httpGET('/api/loadLiabilityReport', params).subscribe({
      next: data => {
        this.ShowProgressBar = false;
        // The server already returns one page slice. Render it as-is. Do NOT bind
        // dataSource.sort/.paginator: paging and sorting are authoritative on the
        // server, and local binding would re-paginate/re-sort the slice.
        this.liabilityData = data?.['liability_data'] || [];
        this.dataSource.data = this.liabilityData;

        // paginator.length comes from the server's full-set count.
        this.setupPagination(data, params);

        // Summary cards reflect ALL matching students (server full-set totals),
        // never the current page slice.
        this.applyServerSummary(data?.['summary']);
      },
      error: error => {
        this.ShowProgressBar = false;
        LoggerService.error('Error loading liability data:', error);
        this.liabilityData = [];
        this.dataSource.data = [];
        this.applyServerSummary(null);
        this.setupPagination({ count: 0 }, params);
      }
    });
  }

  override setupPagination(data: any, params: { parameter: string; value: string }[]) {
    const sizeParam = params.find(p => p.parameter === 'items_per_page');
    const pageParam = params.find(p => p.parameter === 'page');
    const pageSize = sizeParam ? parseInt(sizeParam.value, 10) : 25;
    this.paginationTotalPages = pageSize;
    this.paginationIndex = pageParam ? parseInt(pageParam.value, 10) : 0;

    if (this.paginator) {
      this.paginator.length = Number(data?.['count'] ?? 0);
      this.paginator.pageSize = pageSize;
      this.paginator.pageIndex = this.paginationIndex;
    }
    // Intentionally NO updateRouterParams() here: the base implementation
    // navigates, which would trigger a second getData() and a redundant full scan.
  }

  private applyServerSummary(s: any) {
    this.totalLessonsRemainingPaid = s?.totalLessonsRemainingPaid ?? 0;
    this.totalLessonsRemainingUnpaid = s?.totalLessonsRemainingUnpaid ?? 0;
    this.totalValuePaidRemaining = s?.totalPaidRemaining ?? 0;
    this.totalValueUnpaidRemaining = s?.totalUnpaidRemaining ?? 0;
    this.totalValueRemaining = s?.totalValueRemaining ?? 0;
    this.totalBalanceDueLessons = s?.totalBalanceDueLessons ?? 0;
    this.totalOwedForServices = s?.totalOwedForServices ?? 0;
    this.totalExpiredValue = s?.totalExpiredValue ?? 0;
    this.totalPaidAhead = s?.totalPaidAhead ?? 0;
    this.totalLiability = s?.totalLiability ?? 0;
  }

  override onPageSizeOptions() {
    return [10, 25, 50, 100];
  }

  override pageChanged(event: PageEvent) {
    this.paginationTotalPages = event.pageSize;
    this.updateRouterParams({
      ...this.routeParams,
      page: event.pageIndex.toString(),
      items_per_page: event.pageSize.toString(),
    });
  }

  override sortDataView(sort: Sort) {
    // Always return to page 0 on a sort change so the user isn't stranded on a
    // now-out-of-range page.
    const rp: any = { ...this.routeParams, page: '0' };
    if (sort.direction) {
      rp.sort_by = sort.active;
      rp.sort_order = sort.direction.toUpperCase();
    } else {
      delete rp.sort_by;
      delete rp.sort_order;
    }
    this.updateRouterParams(rp);
  }

  override async onPrint() {
    // Must happen here, in the click handler: the await below ends the user
    // gesture, so opening the window afterwards trips the popup blocker.
    const printWindow = this._printService.openPrintWindow();
    if (!printWindow) {
      this._snackBar.open(
        'Your browser blocked the print window. Allow pop-ups for this site and try again.',
        'Close', { duration: 8000 });
      return;
    }

    // Export/print covers the FULL set, not just the current page slice.
    let rows: any[];
    try {
      rows = await this.fetchAllRows();
    } catch (error) {
      printWindow.close();
      this.handleError(error);
      return;
    }
    let content = `
      <h2 class="report-title">Student Liability Report</h2>
      <p class="report-period">
        ${this.isDateRangeActive && this.dateTimeRange?.length > 0
          ? `As of: ${this.reportDateService.formatDate(this.dateTimeRange[1])}`
          : `As of: ${this.reportDateService.formatDate(this.reportDateService.currentStudioDateKey())}`
        }
      </p>
    `;

    // Summary Section
    content += `
      <div class="summary-section">
        <h3>Summary Totals</h3>
        <table class="summary-table">
          <tr>
            <td><strong>Total Lessons Remaining (Paid):</strong></td>
            <td>${this.totalLessonsRemainingPaid}</td>
          </tr>
          <tr>
            <td><strong>Total Lessons Remaining (Unpaid):</strong></td>
            <td>${this.totalLessonsRemainingUnpaid}</td>
          </tr>
          <tr>
            <td><strong>Total Value Paid Remaining:</strong></td>
            <td>${this.currencyService.format(this.totalValuePaidRemaining)}</td>
          </tr>
          <tr>
            <td><strong>Total Value Unpaid Remaining:</strong></td>
            <td>${this.currencyService.format(this.totalValueUnpaidRemaining)}</td>
          </tr>
          <tr>
            <td><strong>Total Value of Remaining Lessons:</strong></td>
            <td>${this.currencyService.format(this.totalValueRemaining)}</td>
          </tr>
          <tr>
            <td><strong>Total Balance Due (Lessons Only):</strong></td>
            <td>${this.currencyService.format(this.totalBalanceDueLessons)}</td>
          </tr>
          <tr>
            <td><strong>Total Owed for Services Given:</strong></td>
            <td>${this.currencyService.format(this.totalOwedForServices)}</td>
          </tr>
          <tr>
            <td><strong>Total Received in Advance:</strong></td>
            <td>${this.currencyService.format(this.totalPaidAhead)}</td>
          </tr>
          <tr>
            <td><strong>Total Value of Expired Lessons:</strong></td>
            <td>${this.currencyService.format(this.totalExpiredValue)}</td>
          </tr>
          <tr class="total-row">
            <td><strong>NET LIABILITY:</strong></td>
            <td><strong>${this.currencyService.format(this.totalLiability)}</strong></td>
          </tr>
        </table>
      </div>
    `;

    // Detailed Student Data Section
    content += `
      <div class="section">
        <h3>Detailed Student Liability</h3>
        ${rows.length > 0 ? `
          <table>
            <thead>
              <tr>
                <th>Student Name</th>
                <th># Remaining (Paid)</th>
                <th>$ Value (Paid)</th>
                <th># Remaining (Unpaid)</th>
                <th>$ Value (Unpaid)</th>
                <th>Total Value of Remaining</th>
                <th>Balance Due (Lessons Only)</th>
                <th>$ Owed for Services Given</th>
                <th>$ Received in Advance</th>
                <th>Value of Expired Lessons</th>
                <th>Net Liability ($)</th>
              </tr>
            </thead>
            <tbody>
              ${rows.map(item => `
                <tr>
                  <td>${item.studentName || ''}</td>
                  <td>${item.lessonsRemainingPaid || 0}</td>
                  <td>${this.currencyService.format(item.valuePaidRemaining || 0)}</td>
                  <td>${item.lessonsRemainingUnpaid || 0}</td>
                  <td>${this.currencyService.format(item.valueUnpaidRemaining || 0)}</td>
                  <td>${this.currencyService.format(item.totalValueRemaining || 0)}</td>
                  <td>${this.currencyService.format(item.balanceDueLessons || 0)}</td>
                  <td>${this.currencyService.format(item.owedForServices || 0)}</td>
                  <td>${this.currencyService.format(item.paidAhead || 0)}</td>
                  <td>${this.currencyService.format(item.expiredValue || 0)}</td>
                  <td><strong>${this.currencyService.format(item.totalLiability || 0)}</strong></td>
                </tr>
              `).join('')}
            </tbody>
            <tfoot>
              <tr class="grand-total-row">
                <td>Grand Total</td>
                <td>${this.totalLessonsRemainingPaid}</td>
                <td>${this.currencyService.format(this.totalValuePaidRemaining)}</td>
                <td>${this.totalLessonsRemainingUnpaid}</td>
                <td>${this.currencyService.format(this.totalValueUnpaidRemaining)}</td>
                <td>${this.currencyService.format(this.totalValueRemaining)}</td>
                <td>${this.currencyService.format(this.totalBalanceDueLessons)}</td>
                <td>${this.currencyService.format(this.totalOwedForServices)}</td>
                <td>${this.currencyService.format(this.totalPaidAhead)}</td>
                <td>${this.currencyService.format(this.totalExpiredValue)}</td>
                <td>${this.currencyService.format(this.totalLiability)}</td>
              </tr>
            </tfoot>
          </table>
        ` : '<p>No liability data found</p>'}
      </div>
    `;

    // Report-specific styles (page-break handling now in PrintService)
    const styles = `
      .report-title {
        font-size: 20px;
        text-align: center;
        margin: 5px 0;
      }
      
      .report-period {
        text-align: center;
        font-size: 13px;
        margin: 5px 0 10px 0;
      }
      
      .summary-section {
        margin: 10px 0;
        padding: 8px;
        background-color: #f8f9fa;
        border-radius: 3px;
        display: block;
      }
      
      .summary-section h3 {
        margin: 0 0 5px 0;
        font-size: 15px;
      }
      
      .summary-table {
        width: 100%;
        max-width: 400px;
        margin: 0 auto;
      }
      
      .summary-table td {
        padding: 3px 5px;
        border-bottom: 1px solid #ddd;
      }
      
      .total-row {
        border-top: 2px solid #333;
        font-weight: bold;
      }
      
      .total-row td {
        padding: 5px;
      }
      
      .section {
        margin: 10px 0;
        display: block;
      }
      
      .section h3 {
        margin: 5px 0;
        color: #333;
        border-bottom: 1px solid #ddd;
        padding-bottom: 3px;
        font-size: 15px;
      }
      
      table {
        width: 100%;
        border-collapse: collapse;
        margin: 5px 0;
        font-size: 10px;
      }
      
      th, td {
        border: 1px solid #ddd;
        padding: 3px;
        text-align: left;
      }
      
      th {
        background-color: #f5f5f5;
        font-weight: bold;
      }
      
      tr:nth-child(even) {
        background-color: #f9f9f9;
      }

      .grand-total-row td {
        border-top: 2px solid #333;
        background-color: #f5f5f5;
        font-weight: bold;
      }
    `;

    const title = `Student Liability Report - ${this.reportDateService.formatDate(this.reportDateService.currentStudioDateKey())}`;

    this._printService.print(content, {
      title,
      styles,
      showSchoolName: true,
      promptPrint: true
    }, printWindow);
  }

  override resetForm() {
    // Clear component state
    this.dateTimeRange = [];
    this.isDateRangeActive = false;
    this.dateRangeDisplayValue = '';
    this.dateRangePicker?.clear();
    this.studentFilter = '';
    this.categoryFilter = '';

    // Clear the form
    if (this.form) {
      this.form.resetForm();
    }

    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }

    // Clear all params via the router; the queryParams subscription re-runs getData.
    this.updateRouterParams({});
  }

  async exportToCsv() {
    // Export covers the FULL set, not just the current page slice.
    const rows = await this.fetchAllRows();
    const csvData = [
      ['Student Name', '# Lessons Remaining (Paid)', '$ Value of Paid Remaining',
       '# Lessons Remaining (Unpaid)', '$ Value of Unpaid Remaining',
       'Total Value of Remaining Lessons', 'Actual Balance Due (Lessons Only)',
       '$ Owed for Services Given', '$ Received in Advance', 'Value of Expired Lessons',
       'Net Liability ($)'],
      ...rows.map(item => [
        item.studentName || '',
        item.lessonsRemainingPaid || 0,
        (item.valuePaidRemaining || 0).toFixed(2),
        item.lessonsRemainingUnpaid || 0,
        (item.valueUnpaidRemaining || 0).toFixed(2),
        (item.totalValueRemaining || 0).toFixed(2),
        (item.balanceDueLessons || 0).toFixed(2),
        (item.owedForServices || 0).toFixed(2),
        (item.paidAhead || 0).toFixed(2),
        (item.expiredValue || 0).toFixed(2),
        (item.totalLiability || 0).toFixed(2)
      ]),
      // Grand Total from the server's full-set summary, not a sum of the
      // exported rows (which are capped at 250).
      ['Grand Total',
        this.totalLessonsRemainingPaid,
        this.totalValuePaidRemaining.toFixed(2),
        this.totalLessonsRemainingUnpaid,
        this.totalValueUnpaidRemaining.toFixed(2),
        this.totalValueRemaining.toFixed(2),
        this.totalBalanceDueLessons.toFixed(2),
        this.totalOwedForServices.toFixed(2),
        this.totalPaidAhead.toFixed(2),
        this.totalExpiredValue.toFixed(2),
        this.totalLiability.toFixed(2)
      ]
    ];

    const csvContent = csvData.map(row => row.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `liability-report-${this.reportDateService.currentStudioDateKey()}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  }
}
